import { render, staticRenderFns } from "./modalUpload.vue?vue&type=template&id=6df98530"
import script from "./modalUpload.vue?vue&type=script&lang=js"
export * from "./modalUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports